import React, { useState, useEffect } from "react";
import { Box, Modal, Typography } from "@material-ui/core";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { firestore } from '../../firebase';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getScreams } from '../../redux/actions/dataActions';

const modalBoxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '5px solid #ff0000',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
  backgroundColor: 'black',
  color: 'white',
  textAlign: 'center'
};

const ReportCommentModal = ({ commentIndex, gameId, onClose, user }) => {

  const [modalOpen, setModalOpen] = useState(true);
  const [reported, setReported] = useState(false);
  const [countdown, setCountdown] = useState(2);

  useEffect(() => {
    // When reported state becomes true, start the countdown
    if (reported) {
      const timer = setInterval(() => {
        setCountdown(prevCount => {
          if (prevCount <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prevCount - 1;
        });
      }, 1000);
      
      // Cleanup the timer
      return () => clearInterval(timer);
    }
  }, [reported]);

  const handleReport = async (reportType) => {
    
    

    try {
      const docRef = doc(firestore, "games", gameId.toString());
      const userId = user?.credentials?.userId;

      if (!userId) {
        console.error("User ID is undefined");
        return;
      }

      // First get the full document
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const gameData = docSnap.data();
        const commentsArray = gameData.comments || [];

        // Make sure the comment exists at the specified index
        if (commentIndex >= 0 && commentIndex < commentsArray.length) {
          // Create a deep copy of the comments array
          const updatedComments = JSON.parse(JSON.stringify(commentsArray));
          const commentToUpdate = updatedComments[commentIndex];
          
          // Create the report object
          const reportObject = {
            userId: userId,
            reportType: reportType || 'general', // Default to 'general' if no type provided
            timestamp: new Date().toISOString()
          };
          
          // Initialize reports array if it doesn't exist
          if (!Array.isArray(commentToUpdate.reports)) {
            commentToUpdate.reports = [];
          }
          
          // Add the new report to the array
          commentToUpdate.reports.push(reportObject);
          
          // Update the entire comments array in Firestore
          await updateDoc(docRef, {
            comments: updatedComments
          });

          
          setReported(true);
          
          // Auto-close the modal after 2 seconds
          setTimeout(() => {
            setModalOpen(false);
            onClose();
          }, 2000);
        } else {
          console.error("Comment index out of bounds");
        }
      } else {
        console.error("Game document not found");
      }
    } catch (error) {
      console.error('Error reporting comment:', error);
    }
  };

  return (
    <Modal
      open={modalOpen}
    >
      <Box sx={modalBoxStyle}>
        {!reported ? (
          <>
            <Typography variant="h6" component="h2" style={{ marginBottom: '20px', color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
              Report Comment
            </Typography>

            <div style={{ display: 'flex', gap: '20px', flexDirection: 'column', justifyContent: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', justifyContent: 'center' }}>
                <button onClick={() => handleReport('spam')} style={{ fontSize: '20px', backgroundColor: 'black', color: '#ff0000', border: '3px solid #ff0000', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>Spam</button>
                <button onClick={() => handleReport('offensive')} style={{ fontSize: '20px', backgroundColor: 'black', color: '#ff0000', border: '3px solid #ff0000', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>Offensive</button>
                <button onClick={() => handleReport('other')} style={{ fontSize: '20px', backgroundColor: 'black', color: '#ff0000', border: '3px solid #ff0000', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>Other</button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: '20px', color: 'white', fontWeight: 'bold', fontSize: '24px', marginTop: '20px' }}>
              Comment Reported
            </div>
            <div style={{ color: 'white', marginBottom: '' }}>
              Thank you for keeping our community safe.
            </div>
            
          </>
        )}

        <div style={{ marginTop: '20px' }}>
          {!reported ? (
            <button
              onClick={() => {
                setModalOpen(false);
                onClose();
              }}
              style={{
                padding: '10px 20px',
                border: '2px solid white',
                borderRadius: '5px',
                backgroundColor: '#333',
                color: 'white',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '20px',
              }}
            >
              CANCEL
            </button>
          ) : (
          <></>
            // <button
            //   onClick={() => {
            //     setModalOpen(false);
            //     onClose();
            //   }}
            //   style={{
            //     padding: '10px 20px',
            //     border: '2px solid #4CAF50',
            //     borderRadius: '5px',
            //     backgroundColor: '#4CAF50',
            //     color: 'white',
            //     cursor: 'pointer',
            //     fontWeight: 'bold',
            //     fontSize: '16px',
            //     opacity: '0.8',
            //   }}
            // >
            //   CLOSE NOW
            // </button>
          )}
        </div>
      </Box>
    </Modal>
  );
};

ReportCommentModal.propTypes = {
  commentIndex: PropTypes.number.isRequired,
  gameId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(ReportCommentModal); 